// src/context/ConfigContext.js
import axios from 'axios';
import { createContext, useContext, useEffect, useState } from 'react';

// Create the context with a default value
const ConfigContext = createContext(null);

// Export the useConfig hook
export const useConfig = () => {
  const context = useContext(ConfigContext);
  if (context === undefined || context === null) {
    return { config: { colors: { primary: '#3B82F6' } } }; // Provide fallback
  }
  return context;
};

export const ConfigProvider = ({ children }) => {
  const [config, setConfig] = useState({
    // Default configuration
    colors: {
      primary: '#3B82F6',
      secondary: '#10B981',
      accent: '#8B5CF6',
      textPrimary: '#111827',
      textSecondary: '#6B7280',
      background: '#FFFFFF',
      backgroundAlt: '#F3F4F6',
    },
    typography: {
      headingFont: 'Inter',
      bodyFont: 'Inter',
      baseSize: '16px',
    },
    showOrderSuccessPopup: false,
    orderSuccessPopupContent: "",
  });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const response = await axios.get('/api/config/public');
        if (response.data) {
          setConfig(prevConfig => ({
            ...prevConfig,
            ...response.data
          }));
        }
      } catch (error) {
        console.error('Error fetching configuration:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchConfig();
  }, []);

  return (
    <ConfigContext.Provider value={{ config, loading }}>
      {children}
    </ConfigContext.Provider>
  );
};